import IconButton, { IconButtonProps } from '@mui/material/IconButton';

import { useConfirm } from '../../hooks/useConfirm/useConfirm';
import { ConfirmationDialog, ConfirmationDialogProps } from '../ConfirmationDialog/ConfirmationDialog';

type Props = Omit<IconButtonProps<'button'>, 'onClick'> &
  Omit<ConfirmationDialogProps, 'handleCancel' | 'handleConfirm' | 'open'> & {
    onConfirm: () => void;
    onCancel?: () => void;
    children: React.ReactNode;
  };

export const ConfirmationIconButton = ({
  onConfirm,
  onCancel: onReject,
  title,
  message,
  children,
  disableBackdropClose,
  slotProps,
  ...rest
}: Props) => {
  const { open, handleClickOpen, handleCancel, handleConfirm } = useConfirm({ onConfirm, onReject });

  return (
    <>
      <IconButton onClick={handleClickOpen} {...rest}>
        {children}
      </IconButton>
      <ConfirmationDialog
        open={open}
        handleCancel={handleCancel}
        handleConfirm={handleConfirm}
        title={title}
        message={message}
        slotProps={slotProps}
        disableBackdropClose={disableBackdropClose}
      />
    </>
  );
};
